import React from 'react';
import { CheckCircle, XCircle, AlertCircle, Info, X } from 'lucide-react';
import { useApp } from '../context/AppContext';

const config = {
  success: { bg: 'bg-green-600', icon: CheckCircle },
  error: { bg: 'bg-red-600', icon: XCircle },
  warning: { bg: 'bg-yellow-500', icon: AlertCircle },
  info: { bg: 'bg-blue-600', icon: Info },
};

export default function Notification() {
  const { state, dispatch } = useApp();
  const { notification } = state;

  if (!notification) return null;

  const { bg, icon: Icon } = config[notification.type] || config.info;

  return (
    <div className={`toast ${bg}`}>
      <Icon size={18} />
      <span>{notification.message}</span>
      <button onClick={() => dispatch({ type: 'HIDE_NOTIFICATION' })} className="ml-2 hover:opacity-75">
        <X size={16} />
      </button>
    </div>
  );
}

// Also export a standalone show function pattern via hook
export function useNotification() {
  const { showNotification } = useApp();
  return showNotification;
}
